import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import arrowIcon from '../../../../images/icons/chevron-down.svg';
import ProductPreview from '../../../products/components/product_preview/ProductPreview';
import './ProductsSlider.sass';
import ClickableDiv from '../../../ui_kit/clickable_div/ClickableDiv';

const DESKTOP_WIDTH_BREAKPOINT = 600;

const SLIDES_TO_SHOW_ON_MOBILE = 2;
const SLIDES_TO_SHOW_ON_DESKTOP = 3;

class ProductsSlider extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      slidesToShow: SLIDES_TO_SHOW_ON_MOBILE,
    };
  }

  componentDidMount() {
    this.recalculateSlidesToShow();
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.recalculateSlidesToShow();
  };

  recalculateSlidesToShow = () => {
    const { products } = this.props;

    const slidesToShowSetting = window.innerWidth >= DESKTOP_WIDTH_BREAKPOINT
      ? SLIDES_TO_SHOW_ON_DESKTOP : SLIDES_TO_SHOW_ON_MOBILE;

    const slidesToShow = products.length < slidesToShowSetting
      ? products.length : slidesToShowSetting;

    this.setState({
      slidesToShow,
    });
  };

  onPrevClick = () => {
    this.slider.slickPrev();
  };

  onNextClick = () => {
    this.slider.slickNext();
  };

  render() {
    const { products, addToBag } = this.props;
    const { slidesToShow } = this.state;

    return (
      <div className="products-slider">
        <Slider
          ref={(slider) => {
            this.slider = slider;
          }}
          dots={false}
          slidesToShow={slidesToShow}
          slidesToScroll={1}
          arrows={false}
          infinite
        >
          {products.map((product) => (
            <ProductPreview
              key={product.id}
              product={product}
              addToBag={addToBag}
              className="product-preview"
            />
          ))}
        </Slider>
        { products.length > slidesToShow && (
          <div className="pagination-arrows">
            <ClickableDiv className="prev" onClick={this.onPrevClick}>
              <img src={arrowIcon} alt="Previous Page" />
            </ClickableDiv>
            <ClickableDiv className="next" onClick={this.onNextClick}>
              <img src={arrowIcon} alt="Next Page" />
            </ClickableDiv>
          </div>
        )}
      </div>
    );
  }
}

ProductsSlider.propTypes = {
  addToBag: PropTypes.func,
  products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default ProductsSlider;
